import React, { useEffect, useState, useCallback } from 'react'
import { GetUserLiveDashboardApi } from '../../../../api/request/liveAccount.js';
import DashboardEquity from '../../../../assets/user/DashboardEquity';
import TotalProfit from '../../../../assets/user/TotalProfit';
import UsedMargin from '../../../../assets/user/UsedMargin';
import FreeMargin from '../../../../assets/user/FreeMargin';
import PNLCard from './PNLCard'

const POLLING_INTERVAL = 10000;

const Overview = ({ loginId }) => {
    const [liveData, setLiveData] = useState(null);

    const fetchData = useCallback(async () => {
        if (!loginId) return;
        try {
            const { data } = await GetUserLiveDashboardApi(loginId);
            if (data?.success) {
                setLiveData(data?.data);
            }
        } catch (error) { }
    }, [loginId]);

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [fetchData]);

    const statisticsCards = [
        { title: 'Equity', value: liveData?.equity, color: "bg-[#E9E7FD]", icon: <DashboardEquity color="#7367F0" /> },
        { title: 'Total Profit', value: liveData?.profit, color: 'bg-[#D6F4F8]', icon: <TotalProfit color="#00BAD1" /> },
        { title: 'Used Margin', value: liveData?.margin, color: 'bg-[#FFF0E1]', icon: <UsedMargin color="#FF9F43" /> },
        { title: 'Free Margin', value: liveData?.marginFree, color: 'bg-[#DDF6E8]', icon: <FreeMargin color="#28C76F" /> },
    ];

    return (
        <div className='border-2 border-light rounded-[10px] p-5 h-full'>
            <div className="flex flex-col gap-5 h-full">
                <h2 className="text-lg font-semibold">Statistics</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
                    {statisticsCards?.map((card) => (
                        <PNLCard {...card} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Overview